import { Address } from '@models/address'

export function formatAddress(address?: Address) {
  if (address) {
    return `${address.street}, ${address.city}, ${address.state} ${address.zipCode}`
  }

  return ''
}
